module.exports = __webpack_public_path__ + "static/media/check-box-checked.80a14ab3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/check-box-checked.svg
// module id = 881
// module chunks = 21